import { render, staticRenderFns } from "./PubMenu.vue?vue&type=template&id=3f76cc5e"
import script from "./PubMenu.vue?vue&type=script&lang=js"
export * from "./PubMenu.vue?vue&type=script&lang=js"
import style0 from "./PubMenu.vue?vue&type=style&index=0&id=3f76cc5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports